export default __webpack_public_path__ + "static/media/mexico-icon.a6c432c5.svg";